/*
  Verwachte verzending altijd actueel (Claude, 29/10/2026)
  Vroeger rekende enkel de winkelwagenpagina dit uit, bij het laden van die pagina. Wie daarna nog iets toevoegde of
  via de winkelwagen-lade afrekende, kreeg een oude berekening mee (bv. '1-2 werkdagen' voor een artikel dat besteld moet worden).
  Ook telde een artikel als 'op voorraad' zodra er 1 stuk lag, ook als de klant er meer bestelde.
  Nu: na elke wijziging van de winkelwagen en vlak voor het afrekenen (lade, winkelwagenpagina, alle talen) haalt dit script
  de levertijd van de actuele winkelwagen op (sections/btol-levertijd.liquid, aantal tegenover voorraad) en zet het de
  kenmerken 'Verwachte verzending' en 'Uiterste verzenddatum' opnieuw.
*/
(function () {
  if (window.btolLevertijd || !window.fetch) return;
  var eigen = window.fetch.bind(window);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var feestdagen = [
    '2026-01-01','2026-04-06','2026-05-01','2026-05-14','2026-05-25','2026-07-21','2026-08-15','2026-11-01','2026-11-11','2026-12-25',
    '2027-01-01','2027-03-29','2027-05-01','2027-05-06','2027-05-17','2027-07-21','2027-08-15','2027-11-01','2027-11-11','2027-12-25',
    '2028-01-01','2028-04-17','2028-05-01','2028-05-25','2028-06-05','2028-07-21','2028-08-15','2028-11-01','2028-11-11','2028-12-25'
  ];
  function pad(n) { return String(n).padStart(2, '0'); }
  function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function werkdagenVanaf(start, n) {
    var d = new Date(start); d.setHours(12, 0, 0, 0);
    var tel = 0;
    while (tel < n) {
      d.setDate(d.getDate() + 1);
      var dag = d.getDay();
      if (dag !== 0 && dag !== 6 && feestdagen.indexOf(iso(d)) === -1) tel++;
    }
    return d;
  }

  var actueel = false, bezig = null, timer = null;

  function zetVelden(tekst, datum, dagen) {
    document.querySelectorAll('input[name="attributes[Verwachte verzending]"]').forEach(function (i) { i.value = tekst; });
    document.querySelectorAll('input[name="attributes[Uiterste verzenddatum]"]').forEach(function (i) {
      i.value = datum;
      if (i.hasAttribute('data-dagen')) i.setAttribute('data-dagen', String(dagen));
    });
  }

  function bereken() {
    if (bezig) return bezig;
    bezig = eigen(root + '?sections=btol-levertijd', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('levertijd'); return r.json(); })
      .then(function (s) {
        var html = s && s['btol-levertijd'];
        var m = html && html.match(/<script[^>]*data-btol-levertijd[^>]*>([\s\S]*?)<\/script>/);
        if (!m) throw new Error('levertijd');
        var d = JSON.parse(m[1]);
        if (!d.stuks) { actueel = true; return; }
        var dagen = parseInt(d.dagen, 10) || 0;
        var datum = dagen > 0 && dagen < 999 ? iso(werkdagenVanaf(new Date(), dagen)) : '';
        zetVelden(d.tekst, datum, dagen);
        return eigen(root + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Verwachte verzending': d.tekst, 'Uiterste verzenddatum': datum } })
        }).then(function (r) { if (r.ok) actueel = true; });
      })
      .catch(function () {})
      .then(function () { bezig = null; });
    return bezig;
  }

  function plan() {
    actueel = false;
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (bezig) { bezig.then(plan); return; }
      bereken();
    }, 250);
  }

  /* elke wijziging aan de winkelwagen (toevoegen, aantal, verwijderen) */
  var vorige = window.fetch;
  window.fetch = function (input) {
    var u = typeof input === 'string' ? input : (input && input.url) || '';
    var p = vorige.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u)) p.then(function () { plan(); }, function () {});
    return p;
  };
  ['cart:change', 'cart:refresh', 'cart:updated', 'variant:add'].forEach(function (ev) { document.addEventListener(ev, plan); });

  /* afrekenen: eerst de levertijd van de actuele winkelwagen zetten, dan pas door naar de checkout */
  var doorlaten = false;
  function afrekenen(e, knop) {
    if (doorlaten || actueel) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var klaar = false;
    function verder() {
      if (klaar) return;
      klaar = true;
      doorlaten = true;
      setTimeout(function () { doorlaten = false; }, 4000);
      if (knop.tagName === 'A') { location.href = knop.href; return; }
      var f = knop.form || knop.closest('form');
      if (f && f.requestSubmit) { f.requestSubmit(knop.matches('button, input') ? knop : undefined); return; }
      if (f) {
        var i = document.createElement('input'); i.type = 'hidden'; i.name = 'checkout'; i.value = '1'; f.appendChild(i);
        f.submit(); return;
      }
      location.href = root + 'checkout';
    }
    Promise.resolve(bezig || bereken()).then(verder, verder);
    setTimeout(verder, 3000);
  }
  document.addEventListener('click', function (e) {
    var k = e.target && e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (k) afrekenen(e, k);
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target, s = e.submitter;
    if (!f || !f.action || !/\/cart(\?|$)/.test(f.action) || !s || s.name !== 'checkout') return;
    afrekenen(e, s);
  }, true);

  /* bij het openen van een pagina (ook terug via de knop 'vorige'): de winkelwagen meteen nakijken */
  function heeftWagen() { return /(?:^|;\s*)cart=/.test(document.cookie); }
  if (heeftWagen()) plan();
  window.addEventListener('pageshow', function (e) { if (e.persisted && heeftWagen()) plan(); });

  window.btolLevertijd = { nu: function () { actueel = false; return bezig || bereken(); } };
})();
